import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Trans, useTranslation } from 'react-i18next';

import { Box } from '@mui/system';
import { Typography } from '@mui/material';

import store from '../../../../store';
import {
    setSelectedMeshId,
    setSelectedProjectElementId,
} from '../../../../store/actions/Project';

import SearchProjectElements from './SearchProjectElements';
import ElementInfo from './ElementInfo';
import apiClient from '../../../../services/api';
import { toggleMessageOpen } from '../../../../store/actions/Message';
import { LoadingScreen } from '../../../partials/LoadingScreen';

// import { IS_DEV } from '../../../../isdev';

function ProductsFixturesTab(props) {
    const { type, isPublic } = props;
    const { t } = useTranslation();

    const [elements, setElements] = useState([]);
    const [loading, setLoading] = useState(false);

    const fetching = useSelector((state) => state.project.projectIsLoading);
    const selectedProjectData = useSelector((state) => state.project.selectedProject);
    const projectElements = useSelector((state) => state.project.elements);
    const selectedMeshId = useSelector((state) => state.project.selectedMeshId);
    const selectedProjectElementId = useSelector((state) => state.project.selectedProjectElementId);

    const onRowClick = (item) => {
        const { external_id, guid } = item;
        if (external_id === selectedMeshId && guid.toUpperCase() === selectedProjectElementId ) {
            store.dispatch(setSelectedMeshId(null));
            store.dispatch(setSelectedProjectElementId(null));
        } else {
            store.dispatch(setSelectedMeshId(external_id));
            store.dispatch(setSelectedProjectElementId(guid.toUpperCase()));
        }
    };

    const downloadReportPdf = () => {
        setLoading(true);

        const data = {
            id: selectedProjectData.project.id,
            type: type
        };

        apiClient.post('/api/projects/generate-report-pdf', data).then(response => {
            if(response.data.success) {
                //const pdfWindow = window.open();
                //pdfWindow.location.href = response.data.pdf;

                window.open(response.data.pdf, '_blank', 'noopener,noreferrer');

                store.dispatch(toggleMessageOpen(t('PDF generated successfully!'), 'success'));
            } else {
                console.log('1', response);
                store.dispatch(toggleMessageOpen(t('An error occurred while generating PDF!'), 'error'));
            }

            setLoading(false);
        }).catch(error => {
            console.log('2', error);
            store.dispatch(toggleMessageOpen(t('An error occurred while generating PDF!'), 'error'));

            setLoading(false);
        })
    }

    useEffect(() => {
        if (projectElements && selectedProjectData) {
            const rows = selectedProjectData[type] || [];
            const indexed = rows.map((r, i) => ({ ...r, index: i }));
            setElements(indexed);
        }
    }, [projectElements, selectedProjectData, type]);

    const selectedChecker = (row) => {
        return row.guid.toUpperCase() == selectedProjectElementId; // selectedMeshId
    };

    const selected = selectedMeshId || selectedProjectElementId;

    return fetching ? (
        <Typography><Trans>Loading Project</Trans>...</Typography>
    ) : (
        <Box display="flex" flexDirection="column" justifyContent="space-between" height="100%">
            <Box flexGrow={selected ? 0 : 1} flexShrink={selected ? 1 : 0} minHeight={0}>
                <SearchProjectElements
                    elements={elements}
                    onRowClick={onRowClick}
                    selectedChecker={selectedChecker}
                    downloadReportPdf={downloadReportPdf}
                    loading={loading}
                    setLoading={setLoading}
                    isPublic={isPublic}
                />
            </Box>
        </Box>
    );
}

export default ProductsFixturesTab;
